import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import styles from './EmailSuccess.module.scss';
import { Button } from '@src/components/ui';
const EmailSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { verifyEmail } = useAuth();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [verified, setVerified] = useState(false);
    const token = searchParams.get('token');
    const uid = searchParams.get('uid');
    useEffect(() => {
        if (!token || !uid) {
            setError('Missing token or UID.');
            setLoading(false);
            return;
        }
        verifyEmail(token, uid).then((res) => {
            if (res.success) {
                setVerified(true);
            }
            else {
                setError(res.message || 'Could not verify email.');
            }
            setLoading(false);
        });
    }, [token, uid, verifyEmail]);
    if (loading) {
        return _jsx("p", { className: styles.loading, children: "Verifying your email..." });
    }
    return (_jsxs("div", { className: styles.emailSuccessWrapper, children: [verified && (_jsx("div", { className: styles.successBanner, children: "\u2705 Email verified! You can now set up your clinic." })), _jsxs("div", { className: styles.headingContainer, children: [_jsx("h3", { children: verified ? 'Thanks!' : 'Oops!' }), verified ? (_jsxs(_Fragment, { children: [_jsx("p", { children: "Your email has been verified. Click below to set up your clinic. We\u2019ll manually review it and notify you once approved." }), _jsx(Button, { variant: "primaryV2", label: "Set Up My Clinic", onClick: () => navigate(`/account/createClinic?uid=${uid}`) })] })) : (_jsxs("p", { className: styles.error, children: ["Verification failed: ", error] }))] })] }));
};
export default EmailSuccess;
